// extracted by mini-css-extract-plugin
module.exports = {"merchantsName":"MerchantDistribution_merchantsName__R7TyQ","avatar":"MerchantDistribution_avatar__1mjhs"};